angular.module('rjmNg.directives').directive "resizerListener", [
  "$window"
  "$parse"
  ($window, $parse) ->
    restrict: "A"
    priority: 500
    require: "resizerListener"
    controller: [
      "$scope"
      "$element"
      "$attrs"
      ($scope, $element, $attrs) ->
        @resize = (width, height) ->
          context = {
            width: width
            height: height
          }

          if $attrs.heightMatchWindow
            context.height = angular.element($window).height()
          if $attrs.widthMatchWindow
            context.width = angular.element($window).width()

          if $attrs.heightMatchParent
            context.height = $element.parent().height()
          if $attrs.widthMatchParent
            context.width = $element.parent().width()

          if $attrs.widthModifier?
            widthGetter = $parse("width#{$attrs.widthModifier}")
            context.width = widthGetter(context)
          if $attrs.heightModifier?
            heightGetter = $parse("height#{$attrs.heightModifier}")
            context.height = heightGetter(context)

          $element.height(context.height).width(context.width)
          $scope.$broadcast "enlargedDashboardItemResized", context.width, context.height

        @
    ]
    link: (scope, elem, attrs, controller) ->
      listener = scope.$on "resizer-resize", (event, width, height) ->
        controller.resize(width, height)

      scope.$on '$destroy', listener
  ]
